import { TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { IAirTimeRegistrationRepository } from "features/airTimeRegistration/domain/repositories/IAirTimeRegistrationRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { AirTimeRegistrationRequestModel } from "./model/AirTimeRegistrationRequestModel";
import { AirTimeRegistrationResponseModel } from "./model/AirTimeRegistrationResponseModel";

@injectable()
export class AirTimeRegistrationImpl implements IAirTimeRegistrationRepository {
  async getList(
    params: AirTimeRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<AirTimeRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<AirTimeRegistrationRequestModel>(
      TRANSACTION_HISTORY.AIRTIMELIST,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: AirTimeRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<AirTimeRegistrationResponseModel>> {
    return;
  }

  async exportReport(
    params: AirTimeRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      TRANSACTION_HISTORY.AIRTIMELIST,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
